import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Formats a booking ID for display purposes.
 * Returns the last 8 characters of the booking ID with a # prefix.
 * If the booking ID is shorter than 8 characters, returns the full ID.
 * Returns an empty string if the booking ID is null, undefined, or empty.
 *
 * @param bookingId - The booking ID to format
 * @returns Formatted booking ID string (e.g., "#12345678") or empty string
 */
export function displayBookingId(bookingId: string | null | undefined): string {
  if (!bookingId || bookingId.trim() === '') {
    return '';
  }

  // If the ID is 8 characters or less, use the full ID
  if (bookingId.length <= 8) {
    return `#${bookingId}`;
  }

  // Otherwise, use the last 8 characters
  return `#${bookingId.slice(-8)}`;
}
